import { render, staticRenderFns } from "./taxBaseSummaryBox.vue?vue&type=template&id=10293e48&"
import script from "./taxBaseSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./taxBaseSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports